import { createSlice } from "@reduxjs/toolkit"
import { ReportsModel } from "../../models/reports.model"

import { format } from "date-fns"

const getTodayString = () => format(new Date(), "dd-MM-yyyy")

const InitialDate = {
    startDate: getTodayString(),
    endDate: getTodayString(),
    startHour: "00:00",
    endHour: "23:59",
}
export const currentReportDataSlice = createSlice({
    name: "current-order",
    initialState: {
        currentReportData: ReportsModel,
        selectedDateTime: InitialDate
    },
    reducers: {
        setCurrentReportData: (state, action) => {
            state.currentReportData = action.payload
        },
        setSelectedDateTime: (state, action) => {
            state.selectedDateTime = action.payload
        }
    }
})
export const {
    setCurrentReportData,
    setSelectedDateTime,
} = currentReportDataSlice.actions